let BUNDLE_LINK_PREFIX = '/a/loop_subscriptions/bundle'
const LOOP_BUNDLE_URL = 'https://api-service.loopwork.co/bundleTransaction/getBundleCartDetails'
const LOOP_API_SERVICE_URL = 'https://api-service.loopwork.co'
let BUNDLE_CONTAINER_CLASS = 'BUNDLE_CONTAINER_CLASS'
let CART_SUBTOTAL_CLASS = 'cart-subtotal__price'

const getItemsHtml = (item) => {
  return `<p><span class="data-cart-item-selling-plan-name">${item.title || ''} x ${item.quantity || ''}</span></p>`
}

const getBundleCartItemsTemplate = (bundleItem, index, bundleLink) => {
  console.log('bundle', bundleItem)
  let istryMeKitId = bundleItem?.items[0]?.properties?._Trymekitproductprice != undefined
  let finalPriceForTryMe = `${bundleItem?.currencySymbol}`
  let sum = 0
  bundleItem?.items.map((item, index) => {
    sum += parseInt(item?.properties?._Trymekitproductprice) / 100
  })
  finalPriceForTryMe += sum
  let DefaultName = 'Build a Box'
  if (bundleLink == '/a/loop_subscriptions/bundle/7392593d058048c6b33e9d9aade2ba23') {
    DefaultName = 'Lash Bundle'
  }

  const perItemDiscountedPrice = (bundleItem.priceWithoutCurrency / bundleItem.totalItems).toFixed(2)
  const perItemPrice = (bundleItem.priceWithoutDiscountAndCurrency / bundleItem.totalItems).toFixed(2)
  const addDisplayNoneClassBundle = bundleItem.priceWithoutDiscount == bundleItem.price
  const addDisplayNoneClassBundleItem = perItemDiscountedPrice == perItemPrice
  // console.log(addDisplayNoneClassBundle, addDisplayNoneClassBundleItem)
  // console.log(bundleItem.priceWithoutDiscount, bundleItem.price)
  return `
        <tr id="CartBundleItem-${index}" class="cart-item cart__row medium-hide large-up-hide" style="display:flex; justify-content: space-between; margin-bottom: -4rem !important;">
    <td colspan="2" >
        <div id="${bundleItem.bundleId}" class="cart__product-information">
                
            <div>
             <h3 style="margin:0">${DefaultName}</h3>
            <div class="list-view-item__title">  <a href="${bundleLink}" class="cart-item__name break">${
    bundleItem.label || ''
  }</a></div>
          <p style="margin: 4px 0;"  class="product-details__item product-details__item--variant-option"><span class="data-cart-item-selling-plan-name">${
            bundleItem.sellingPlan || ''
          }</span></p>
            </div>
            <p style="margin: 4px 0 20px 0;"  class="product-details__item product-details__item--variant-option">
            <a onclick="removeBundle('${bundleItem.bundleId}')" style="cursor:pointer; text-decoration: underline;">
              Remove
            </a>
            </p>
        </div>
    </td>

    <td class="cart-item__totals right medium-hide large-up-hide small-hide" >
        <div class="cart-item__price-wrapper"  style="display:flex; gap:5px;justify-content: end;">
            <span class="strike-through" style="text-decoration: line-through;">${`${
              addDisplayNoneClassBundle ? '' : `${istryMeKitId ? finalPriceForTryMe : bundleItem.priceWithoutDiscount}`
            }`}</span>
            <span class="test original-price">${`${
              istryMeKitId ? `${bundleItem.currencySymbol}5` : bundleItem.price
            }`}</span>
        </div>          
    </td>

    <td class="cart-item__quantity" >
        <span class="small-hide">${bundleItem.quantity}</span>
        <div class="cart-item__price-wrapper medium-hide large-up-hide"  style="display:flex; gap:5px;justify-content: end;">
            <span class="strike-through" style="text-decoration: line-through;">${`${
              addDisplayNoneClassBundle ? '' : `${istryMeKitId ? finalPriceForTryMe : bundleItem.priceWithoutDiscount}`
            }`}</span>
            <span class="test original-price">${`${
              istryMeKitId ? `${bundleItem.currencySymbol}5` : bundleItem.price
            }`}</span>
        </div>
    </td>

    <td class="cart-item__totals right small-hide" >
        <div class="cart-item__price-wrapper"  style="display:flex; gap:5px;justify-content: end;">
            <span class="strike-through" style="text-decoration: line-through;">${`${
              addDisplayNoneClassBundle ? '' : `${istryMeKitId ? finalPriceForTryMe : bundleItem.priceWithoutDiscount}`
            }`}</span>
            <span class="test original-price">${`${
              istryMeKitId ? `${bundleItem.currencySymbol}5` : bundleItem.price
            }`}</span>
        </div>
    </td>
</tr>
<tr id="CartBundleItem-${index}" class="cart-item cart__row small-hide">
    <td colspan="2" >
        <div id="${bundleItem.bundleId}" class="cart__product-information">
                
            <div>
             <h3 style="margin:0">${DefaultName}</h3>
            <div class="list-view-item__title">  <a href="${bundleLink}" class="cart-item__name break">${
    bundleItem.label || ''
  }</a></div>
          <p style="margin: 4px 0;"  class="product-details__item product-details__item--variant-option"><span class="data-cart-item-selling-plan-name">${
            bundleItem.sellingPlan || ''
          }</span></p>
            </div>
            <p style="margin: 4px 0 20px 0;"  class="product-details__item product-details__item--variant-option">
            <a onclick="removeBundle('${bundleItem.bundleId}')" style="cursor:pointer; text-decoration: underline;">
              Remove
            </a>
            </p>
        </div>
    </td>

    <td class="cart-item__totals right medium-hide large-up-hide small-hide" >
        <div class="cart-item__price-wrapper"  style="display:flex; gap:5px;justify-content: end;">
            <span class="strike-through" style="text-decoration: line-through;">${`${
              addDisplayNoneClassBundle ? '' : `${istryMeKitId ? finalPriceForTryMe : bundleItem.priceWithoutDiscount}`
            }`}</span>
            <span class="test original-price">${`${
              istryMeKitId ? `${bundleItem.currencySymbol}5` : bundleItem.price
            }`}</span>
        </div>
    </td>

    <td class="cart-item__quantity" >
        <span class="small-hide" style="padding:20px">${bundleItem.quantity}</span>
        <div class="cart-item__price-wrapper medium-hide large-up-hide"  style="display:flex; gap:5px;justify-content: end;">
            <span class="strike-through" style="text-decoration: line-through;">${`${
              addDisplayNoneClassBundle ? '' : `${istryMeKitId ? finalPriceForTryMe : bundleItem.priceWithoutDiscount}`
            }`}</span>
            <span class="test original-price">${`${
              istryMeKitId ? `${bundleItem.currencySymbol}5` : bundleItem.price
            }`}</span>
        </div>
    </td>

    <td class="cart-item__totals right small-hide" >
        <div class="cart-item__price-wrapper"  style="display:flex; gap:5px;justify-content: end;">
            <span class="strike-through" style="text-decoration: line-through;">${`${
              addDisplayNoneClassBundle ? '' : `${istryMeKitId ? finalPriceForTryMe : bundleItem.priceWithoutDiscount}`
            }`}</span>
            <span class="test original-price">${`${
              istryMeKitId ? `${bundleItem.currencySymbol}5` : bundleItem.price
            }`}</span>
        </div>
    </td>
</tr>
<tr>
<td style="margin:0; padding:0"><hr style="margin:0; padding:0; border-bottom: 1px solid rgba(239, 239, 239, 1);"></td>
<td style="margin:0; padding:0"><hr style="margin:0; padding:0; border-bottom: 1px solid rgba(239, 239, 239, 1);"></td>
<td style="margin:0; padding:0"><hr style="margin:0; padding:0; border-bottom: 1px solid rgba(239, 239, 239, 1);"></td>
<td style="margin:0; padding:0"><hr style="margin:0; padding:0; border-bottom: 1px solid rgba(239, 239, 239, 1);"></td>
</tr>
<hr class="medium-hide large-up-hide" style="margin-bottom:20px; padding:0; border-bottom: 1px solid rgba(239, 239, 239, 1);">

            ${bundleItem.items
              .map((item, index) => {
                // console.log(item.url)
                let lineItemPrice =
                  bundleItem?.currencySymbol + '' + parseInt(item?.properties?._Trymekitproductprice) / 100
                console.log(lineItemPrice)
                const isLastRow = index === bundleItem.items.length - 1
                const borderStyle = isLastRow ? 'margin-bottom: -3rem !important;' : ''

                return `<tr id="cartrow-${index.length}" class="cart-item cart__row">
    <td style="${borderStyle}" class="cart-item__media">
        <a href="${item.url}" class="cart-item__link" aria-hidden="true" tabindex="-1">
        </a>
        <div class="cart-item__image-container gradient global-media-settings">
            <img  src="${item.image || ''}" alt="${
                  bundleItem.label
                }" class="cart-item__image" alt="10mm" loading="lazy" width="150" height="150">
        </div>

    </td>

    <td style="${borderStyle}" class="cart-item__details"><a href="${item.url}" class="cart-item__name h4 break">${
                  item.title.split(' - ')[0] || ''
                }</a>
        <div class="cart__product-information small-hide">
            <ul class="product-details" data-cart-item-details=""
                aria-label="Translation missing: en.cart.label.product_details">
                <p class="product-details__item product-details__item--variant-option" data-cart-item-option="">
                    ${`${istryMeKitId ? '' : `Length: ${item.variant_title || ''}`}`}
                </p>
                <li class="product-details__item product-details__item--property hide" data-cart-item-property=""><span
                        class="product-details__item-label" data-cart-item-property-name="">t:
                    </span><span data-cart-item-property-value="">e
                    </span>
                </li>
            </ul>
        </div>
        <div class="cart__product-informatio medium-hide large-up-hide">
            <p class="product-details__item product-details__item--variant-option" data-cart-item-option="">
                    
                    ${`${istryMeKitId ? '' : `Length: ${item.variant_title || ''}`}`}
                </p>
        </div>
        <p class="product-option"></p>
        <ul class="discounts list-unstyled" role="list" aria-label="Discount"></ul>
    </td>

    <td class="cart-item__totals right medium-hide large-up-hide" style="${borderStyle}">
        <div class="loading-overlay hidden">
            <div class="loading-overlay__spinner">
                <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66"
                    xmlns="http://www.w3.org/2000/svg">
                    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                </svg>
            </div>
        </div>
        <div style="display:grid;">
          <div class="cart-item__price-wrapper" style="display:flex; gap:5px;justify-content: end;">
              <span class="price price--end  strike-through" style="text-decoration: line-through;">${
                addDisplayNoneClassBundleItem
                  ? ''
                  : `${istryMeKitId ? lineItemPrice : `${bundleItem.currencySymbol}${item.quantity * perItemPrice}`}`
              }</span>
              <span class="price price--end  test original-price">${
                istryMeKitId
                  ? `${index == bundleItem.items.length - 1 ? `${bundleItem.currencySymbol}5` : 'Free'}`
                  : `${bundleItem.currencySymbol}${item.quantity * perItemDiscountedPrice}`
              }</span>
          </div>
          <div style="display:flex; gap : 5px; align-items:center;">
          <div>Qty</div>
          <quantity-popover>
            <div class="cart-item__quantity-wrapper quantity-popover-wrapper">
                <label class="visually-hidden" for="Quantity-1">
                    Quantity
                </label>
                <div class="quantity-popover-container"><quantity-input class="quantity cart-quantity">
                        <button class="quantity__button no-js-hidden disabled" name="minus" type="button">
                            <span class="visually-hidden">Decrease quantity for Originals</span>
                            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"
                                class="icon icon-minus" fill="none" viewBox="0 0 10 2">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor">
                                </path>
                            </svg>

                        </button>
                        <input disabled class="quantity__input" data-quantity-variant-id="32868135174226" type="number"
                            name="updates[]" value="${item.quantity || ''}" data-cart-quantity="1" min="1" step="1"
                            aria-label="Quantity for Originals" id="Quantity-1" data-index="1">
                        <button class="quantity__button no-js-hidden" name="plus" type="button">
                            <span class="visually-hidden">Increase quantity for Originals</span>
                            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"
                                class="icon icon-plus" fill="none" viewBox="0 0 10 10">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z"
                                    fill="currentColor">
                                </path>
                            </svg>

                        </button>
                    </quantity-input>
                </div>

            </div>
            <div class="cart-item__error" id="Line-item-error-1" role="alert">
                <small class="cart-item__error-text"></small>
                <svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13">
                    <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle>
                    <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle>
                    <path
                        d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z"
                        fill="white"></path>
                    <path
                        d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z"
                        fill="white" stroke="#EB001B" stroke-width="0.7">
                    </path>
                </svg>
            </div>
        </quantity-popover>
          </div>
        </div>
    </td>
    <td class="cart-item__quantity small-hide" style="${borderStyle}">
        <quantity-popover>
            <div class="cart-item__quantity-wrapper quantity-popover-wrapper">
                <label class="visually-hidden" for="Quantity-1">
                    Quantity
                </label>
                <div class="quantity-popover-container"><quantity-input class="quantity cart-quantity">
                        <button class="quantity__button no-js-hidden disabled" name="minus" type="button">
                            <span class="visually-hidden">Decrease quantity for Originals</span>
                            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"
                                class="icon icon-minus" fill="none" viewBox="0 0 10 2">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor">
                                </path>
                            </svg>

                        </button>
                        <input disabled class="quantity__input" data-quantity-variant-id="32868135174226" type="number"
                            name="updates[]" value="${item.quantity || ''}" data-cart-quantity="1" min="1" step="1"
                            aria-label="Quantity for Originals" id="Quantity-1" data-index="1">
                        <button class="quantity__button no-js-hidden" name="plus" type="button">
                            <span class="visually-hidden">Increase quantity for Originals</span>
                            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"
                                class="icon icon-plus" fill="none" viewBox="0 0 10 10">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z"
                                    fill="currentColor">
                                </path>
                            </svg>

                        </button>
                    </quantity-input>
                </div>

            </div>
            <div class="cart-item__error" id="Line-item-error-1" role="alert">
                <small class="cart-item__error-text"></small>
                <svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13">
                    <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle>
                    <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle>
                    <path
                        d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z"
                        fill="white"></path>
                    <path
                        d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z"
                        fill="white" stroke="#EB001B" stroke-width="0.7">
                    </path>
                </svg>
            </div>
        </quantity-popover>
    </td>

    <td class="cart-item__totals right small-hide" style="${borderStyle}">
        <div class="loading-overlay hidden">
            <div class="loading-overlay__spinner">
                <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66"
                    xmlns="http://www.w3.org/2000/svg">
                    <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                </svg>
            </div>
        </div>
        <div class="cart-item__price-wrapper" style="display:flex; gap:5px;justify-content: end;">
            <span class="price price--end  strike-through" style="text-decoration: line-through;">${
              addDisplayNoneClassBundleItem
                ? ''
                : `${istryMeKitId ? lineItemPrice : `${bundleItem.currencySymbol}${item.quantity * perItemPrice}`}`
            }</span>
            <span class="price price--end  test original-price">${
              istryMeKitId
                ? `${index == bundleItem.items.length - 1 ? `${bundleItem.currencySymbol}5` : 'Free'}`
                : `${bundleItem.currencySymbol}${item.quantity * perItemDiscountedPrice}`
            }</span>
        </div>
    </td>
</tr>
${
  isLastRow
    ? '<hr class="medium-hide large-up-hide" style="margin-bottom:20px; padding:0; border-bottom: 1px solid rgba(239, 239, 239, 1);">'
    : ''
}
${
  isLastRow
    ? '<tr> <td style="margin:0; padding:0"><hr style="margin:0; padding:0; border-bottom: 1px solid rgba(239, 239, 239, 1);"></td> <td style="margin:0; padding:0"><hr style="margin:0; padding:0; border-bottom: 1px solid rgba(239, 239, 239, 1);"></td> <td style="margin:0; padding:0"><hr style="margin:0; padding:0; border-bottom: 1px solid rgba(239, 239, 239, 1);"></td> <td style="margin:0; padding:0"><hr style="margin:0; padding:0; border-bottom: 1px solid rgba(239, 239, 239, 1);"></td></tr>'
    : ''
}
               `
              })
              .join('')}




    `
}

const getBundleCartDrawerTemplate = (bundleItem, index, bundleLink) => {
  return `
        <tr class="cart-item" id="CartBundleItem-${index}">
              <td class="cart-item__media" style="text-align:center;">
                <img class="cart-item__image" src="${bundleItem.image || ''}" alt="${
    bundleItem.label
  }" loading="lazy" width="75" height="75">
              </td>
              <td class="cart-item__details">
                    <a href="${bundleLink}" class="cart-item__name break">${
    bundleItem.label || ''
  }</a><dl><div class="product-option">
                    ${bundleItem.items
                      .map((item) => {
                        return `<p><span style="display:block;" class="data-cart-item-selling-plan-name">${
                          item.title || ''
                        } x ${item.quantity || ''}</span></p>`
                      })
                      .join('')}
                    <br/><p><span class="data-cart-item-selling-plan-name">${bundleItem.sellingPlan || ''}</span></p>
              </td>

              <td class="cart-item__quantity small-hide">
                    ${bundleItem.quantity}
              </td>

              <td class="cart-item__totals right small-hide">
                <div class="cart-item__price-wrapper medium-up"><span class="price price--end">
                       ${bundleItem.amount}
                       </span>
                  </div>

                  <div onclick="removeBundle('${
                    bundleItem.bundleId
                  }')" style="cursor:pointer; width: fit-content;height: 15px;display: inline-flex;flex-direction: row-reverse;">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" style="width: 1em; height: 1em;" aria-hidden="true" focusable="false" role="presentation" class="icon icon-remove">
                          <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
                          <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
                    </svg>
                  </div>
                
              </td>

              <td class="right medium-hide large-up-hide">
                <div class="cart-item__price-wrapper medium-up"><span class="price price--end">
                       ${bundleItem.amount}
                       </span>
                  </div>

                  <div onclick="removeBundle('${
                    bundleItem.bundleId
                  }')" style="cursor:pointer; width: fit-content;height: 15px;display: inline-flex;flex-direction: row-reverse;">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" style="width: 1em; height: 1em;" aria-hidden="true" focusable="false" role="presentation" class="icon icon-remove">
                          <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
                          <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
                    </svg>
                  </div>
                
              </td>
            </tr>
    `
}

const getItemKeysByBundleId = (bundleId) => {
  const cartItems = window.Loop.bundleCartAllItems
  const data = {
    updates: {},
  }
  for (const item of cartItems) {
    const _bundleId = item?.properties?._bundleId ?? item?.properties?.bundleId
    if (!_bundleId || _bundleId !== bundleId) continue
    data.updates[item.key] = 0
  }
  return data
}

const removeBundle = async (bundleId) => {
  const data = getItemKeysByBundleId(bundleId)
  const endpoint = `${window.Shopify.routes.root}cart/update.js`
  await fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
  window.location.href = window.location.href
}

const _getSelectedBundleVariants = (bundleId) => {
  const _allBundleCartItems = window.Loop.bundleCartAllItems
  let _selectedVariants = ''
  let _selectedQuantities = ''
  for (const _item of _allBundleCartItems) {
    const _bundleId = _item?.properties?._bundleId ?? _item?.properties?.bundleId
    if (!_bundleId || _bundleId !== bundleId) continue
    _selectedVariants += `${_item.id},`
    _selectedQuantities += `${_item.quantity},`
  }
  return {
    selectedVariants: _selectedVariants.substring(0, _selectedVariants?.length - 1),
    selectedQuantities: _selectedQuantities.substring(0, _selectedQuantities?.length - 1),
  }
}

const _getLoopToken = async (shopifyDomain, bundleId) => {
  const _endpoint = `${LOOP_API_SERVICE_URL}/bundleTransaction/getToken?shopifyDomain=${shopifyDomain}&bundleTransactionId=${bundleId}`
  const _response = await fetch(_endpoint)
  const _jsonRes = await _response.json()
  return _jsonRes?.token ?? 'LOOP_TOKEN'
}

const editBundle = async (bundleId) => {
  console.log(`Editing bundle: ${bundleId}`)
  const { selectedVariants, selectedQuantities } = _getSelectedBundleVariants(bundleId)
  const _shopifyDomain = window?.Shopify?.shop
  const _loopToken = await _getLoopToken(_shopifyDomain, bundleId)
  const _editBundleRef = `${BUNDLE_LINK_PREFIX}/change/${bundleId}?loop_token=${_loopToken}&selectedVariants=${selectedVariants}&selectedQuantities=${selectedQuantities}`
  window.location.href = _editBundleRef
}

const fetchBundleTransactionCartDetails = async (loopBundleGuid) => {
  const _endpoint = `${LOOP_BUNDLE_URL}/${loopBundleGuid}`
  const _response = await fetch(_endpoint)
  return await _response.json()
}

const addExtraDetailsToBundleItems = async (bundleItems) => {
  let totalDiscount = 0
  let currencySymbol = ''
  let currency = ''
  console.log(bundleItems)
  let addOnPrice = 0
  for (let i = 0; i < bundleItems.length; ++i) {
    let try_me = bundleItems[i]?.items[0]?.properties?._Trymekitproductprice != undefined
    console.log(try_me)
    if (try_me) addOnPrice++
    const extraDetails = await fetchBundleTransactionCartDetails(bundleItems[i].bundleId)
    console.log(extraDetails)
    bundleItems[i].label = extraDetails?.label
    bundleItems[i].image = extraDetails?.image
    bundleItems[i].sellingPlan = extraDetails?.name
    let price = bundleItems[i].price
    bundleItems[i].priceWithoutDiscount = `${extraDetails.currencySymbol}${parseFloat(price.toFixed(2))}`
    bundleItems[i].priceWithoutDiscountAndCurrency = parseFloat(price.toFixed(2))
    let _totalItems = 0
    for (const item of bundleItems[i].items) {
      console.log(item)
      _totalItems += item.quantity
    }
    bundleItems[i].totalItems = _totalItems
    console.log(bundleItems[i])
    if (extraDetails.discountType && extraDetails.discountValue) {
      if (extraDetails.discountType === 'PERCENTAGE') {
        if (extraDetails.appliesOnEachItem) {
          // if discount in each item
          if (!try_me) {
            totalDiscount += price * (parseFloat(extraDetails.discountValue) / 100) * _totalItems
          }
          price = price - price * (parseFloat(extraDetails.discountValue) / 100) * _totalItems
        } else {
          if (!try_me) {
            totalDiscount += price * (parseFloat(extraDetails.discountValue) / 100)
          }
          price = price - price * (parseFloat(extraDetails.discountValue) / 100)
        }
      } else {
        if (extraDetails.appliesOnEachItem) {
          // if discount in each item
          if (!try_me) {
            totalDiscount += parseFloat(extraDetails.discountValue) * _totalItems
          }
          price = price - parseFloat(extraDetails.discountValue) * _totalItems
        } else {
          if (!try_me) {
            totalDiscount += parseFloat(extraDetails.discountValue)
          }
          price = price - parseFloat(extraDetails.discountValue)
        }
      }
    }
    bundleItems[i].priceWithoutCurrency = price
    bundleItems[i].price = `${extraDetails.currencySymbol}${parseFloat(price.toFixed(2))}`
    bundleItems[i].amount = `${extraDetails.currencySymbol}${parseFloat(price.toFixed(2))}`
    bundleItems[i].loopBundleId = extraDetails.loopBundleId
    bundleItems[i].currencySymbol = extraDetails.currencySymbol
    currencySymbol = extraDetails.currencySymbol
    currency = extraDetails.currency
  }
  let send = addOnPrice * 5
  console.log(send)

  removeDiscountFromSubtotalInCart(totalDiscount, currencySymbol, currency, send)
}

const removeDiscountFromSubtotalInCart = (totalDiscount, currencySymbol, currency, addOnPrice) => {
  if (totalDiscount < 0) return
  const totalLineItemsPrice = window.Loop.bundleCartAllItems.reduce((acc, item) => {
    return acc + (item.properties._Trymekitproductprice ? 0 : item.price) * item.quantity
  }, 0)
  console.log(totalLineItemsPrice)
  console.log(totalDiscount)
  let discountedPrice = ((totalLineItemsPrice / 100).toFixed(2) - totalDiscount + addOnPrice).toFixed(2)
  console.log(discountedPrice)
  console.log(addOnPrice.toFixed(2))
  let targetNode = null
  targetNode = document.querySelector(`.totals__total-value`)
  console.log(targetNode)
  if (!isNaN(discountedPrice)) {
    targetNode.innerHTML = `${currencySymbol ?? ''}${discountedPrice} ${currency ?? ''}`
  }
  console.log(targetNode.innerHTML)
  /*
  if (
    targetNode &&
    targetNode.firstChild &&
    targetNode.firstChild instanceof HTMLElement
  ) {
    if (
      targetNode.firstChild.firstChild &&
      !(targetNode.firstChild.firstChild instanceof HTMLElement)
    ) {
      targetNode = targetNode.firstChild;
    } else {
      return; // to handle NaN issue if child is actually an Html element and not text => 1 level child
    }
  }

  if (targetNode) {
    let innerHtml = targetNode.innerHTML;
    let priceWithoutCurrency = targetNode.innerHTML;
    let addCurrencyOnText = false;
    let addCurrencySymbol = false;

    if (innerHtml.includes(currency)) {
      addCurrencyOnText = true;
      priceWithoutCurrency = innerHtml.replace(currency, "");
    }

    if (priceWithoutCurrency.includes(currencySymbol)) {
      addCurrencySymbol = true;
      priceWithoutCurrency = priceWithoutCurrency.replace(currencySymbol, "");
    }

    priceWithoutCurrency.trim();
    console.log(priceWithoutCurrency)
    let amount = Number(priceWithoutCurrency) - totalDiscount;
    let newText = `${addCurrencySymbol ? currencySymbol : ""}${amount.toFixed(
      2
    )} ${addCurrencyOnText ? currency : ""}`;
    targetNode.innerHTML = newText;
  } */
}

const getBundleItems = (items) => {
  const bundleItemsMap = {}
  for (const item of items) {
    const bundleId = item?.properties?._bundleId ?? item?.properties?.bundleId
    if (!bundleId) continue
    if (!Object.hasOwn(bundleItemsMap, bundleId)) {
      bundleItemsMap[bundleId] = {
        bundleId,
        quantity: 1,
        price: (Number(item.price) * Number(item.quantity)) / 100,
        amount: (Number(item.price) * Number(item.quantity)) / 100,
        items: [item],
        totalItems: getBundleItems.length,
      }
    } else {
      bundleItemsMap[bundleId].price += (Number(item.price) * Number(item.quantity)) / 100
      bundleItemsMap[bundleId].amount += (Number(item.price) * Number(item.quantity)) / 100
      bundleItemsMap[bundleId].items.push(item)
    }
  }
  return Object.values(bundleItemsMap)
}

const renderBundleItems = (bundleItems, clientId) => {
  const _parent = document.querySelector(`.${clientId}`)
  for (let i = 0; i < bundleItems.length; ++i) {
    const _bundleLink = `${BUNDLE_LINK_PREFIX}/${bundleItems[i].loopBundleId}`
    let _template = undefined
    if (clientId.includes('drawer')) {
      _template = getBundleCartDrawerTemplate(bundleItems[i], i + 1, _bundleLink)
    } else {
      _template = getBundleCartItemsTemplate(bundleItems[i], i + 1, _bundleLink)
    }
    _parent.innerHTML = `${_template} ${_parent.innerHTML}`
  }
}

const bootstrap = async (clientId) => {
  // return
  console.log('clientId', clientId)
  const _cartItems = window.Loop.bundleCartAllItems
  const _bundleItems = getBundleItems(_cartItems)
  await addExtraDetailsToBundleItems(_bundleItems)
  renderBundleItems(_bundleItems, clientId)
}
